import { t } from '@lingui/macro'
import * as SwitchPrimitive from '@radix-ui/react-switch'
import * as React from 'react'

// Define explicit styles for the switch
const switchStyles: React.CSSProperties = {
    display: 'inline-flex',
    height: '20px',
    width: '36px',
    flexShrink: 0,
    cursor: 'pointer',
    borderRadius: '9999px',
    border: '2px solid transparent',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
    transition: 'all 0.2s ease', // eslint-disable-line string-to-lingui/missing-lingui-transformation
    outline: 'none',
    position: 'relative'
}

const switchCheckedStyles: React.CSSProperties = {
    backgroundColor: 'var(--primary)'
}

const switchUncheckedStyles: React.CSSProperties = {
    backgroundColor: 'var(--input)'
}

const switchDisabledStyles: React.CSSProperties = {
    opacity: 0.5,
    cursor: 'not-allowed'
}

const thumbStyles: React.CSSProperties = {
    display: 'block',
    width: '16px',
    height: '16px',
    backgroundColor: 'var(--background)',
    borderRadius: '9999px',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.2s ease', // eslint-disable-line string-to-lingui/missing-lingui-transformation
    transform: 'translateX(0)',
    pointerEvents: 'none'
}

const thumbCheckedStyles: React.CSSProperties = {
    transform: 'translateX(16px)'
}

function Switch({ className, checked, disabled, ...props }: React.ComponentProps<typeof SwitchPrimitive.Root>) {
    return (
        <SwitchPrimitive.Root
            data-slot='switch'
            style={{
                ...switchStyles,
                ...(checked ? switchCheckedStyles : switchUncheckedStyles),
                ...(disabled ? switchDisabledStyles : {})
            }}
            checked={checked}
            disabled={disabled}
            {...props}
            aria-label={t`Toggle`}
        >
            <SwitchPrimitive.Thumb
                data-slot='switch-thumb'
                style={{
                    ...thumbStyles,
                    ...(checked ? thumbCheckedStyles : {})
                }}
            />
        </SwitchPrimitive.Root>
    )
}

export { Switch }
